import React from 'react';

class TruncatedText extends React.Component {
  constructor(props) {
    super(props);
  }

  truncateText = (text, maxWords) => {
    const words = text.split(' ');
    if (words.length <= maxWords) {
      return text;
    }
    return words.slice(0, maxWords).join(' ') + '...';
  };

  render() {
    const { text, maxWords } = this.props;
    const truncatedText = this.truncateText(text, maxWords);

    return (
      <span>{truncatedText}</span>
    );
  }
}

export default TruncatedText;



// WEBPACK FOOTER //
// ./src/utils/truncatedText.js